import { api } from "@nbcom/api";

export const fetchRemoveAuthCookies = async (): Promise<void> =>
  api.get({
    apiUrl: ``,
    url: `api/removeAuthCookiesProxy`,
    credentials: `include`,
  });
